<template>
  <v-card outlined class="rounded-lg">
    <v-card-title class="subtitle-1 font-weight-bold">
      <v-icon color="primary" class="mr-2">mdi-chart-bar</v-icon>Team overview
    </v-card-title>
    <v-card-text>
      <div class="caption font-weight-bold mb-1">Levels</div>
      <div v-for="l in levels" :key="l.level_name" class="d-flex align-center mb-1">
        <span class="caption" style="width:96px">{{ l.level_name }}</span>
        <v-progress-linear :value="max ? (l.count / max) * 100 : 0" color="primary" height="8" rounded class="mx-2" />
        <span class="caption" style="width:24px;text-align:right">{{ l.count }}</span>
      </div>

      <div class="caption font-weight-bold mt-3 mb-1">Average score by pillar</div>
      <div v-for="p in pillars" :key="p.key" class="d-flex align-center mb-1">
        <span class="caption" style="width:96px">{{ p.label }}</span>
        <v-progress-linear :value="average(p.key)" :color="p.color" height="8" rounded class="mx-2" />
        <span class="caption" style="width:24px;text-align:right">{{ average(p.key) }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AdminOverviewCharts',
  props: {
    rows: { type: Array, default: () => [] },
    levelCounts: { type: Array, default: () => [] },
  },
  data() {
    return {
      pillars: [
        { key: 'kpi_score', label: 'KPI', color: 'primary' },
        { key: 'task_score', label: 'Tasks', color: 'teal' },
        { key: 'ai_score', label: 'AI usage', color: 'purple' },
        { key: 'habit_score', label: 'Habits', color: 'orange' },
      ],
    }
  },
  computed: {
    levels() { return this.levelCounts || [] },
    max() { return Math.max(0, ...this.levels.map(l => l.count)) },
  },
  methods: {
    average(key) {
      if (!this.rows.length) return 0
      return Math.round(this.rows.reduce((sum, r) => sum + (r[key] || 0), 0) / this.rows.length)
    },
  },
}
</script>
